import { application } from "./application"

import AudioController from "./audio_controller"
import CarouselController from "./carousel_controller"
import LandingPageBuilderController from "./landing_page_builder_controller"
import QuizBuilderController from "./quiz_builder_controller"
import GalaxyController from "./galaxy_controller"
import CopyLinkController from "./copy_link_controller"
import FormHintController from "./form_hint_controller"
import ModalController from "./modal_controller"
import ParallaxController from "./parallax_controller"
import ParticlesController from "./particles_controller"
import QuizController from "./quiz_controller"
import CountdownController from "./countdown_controller"
import LgpdController from "./lgpd_controller"
import DragSortController from "./drag_sort_controller"
import RevealController from "./reveal_controller"
import LangToggleController from "./lang_toggle_controller"
import DismissibleController from "./dismissible_controller"
import SparklesController from "./sparkles_controller"
import ProductCarouselController from "./product_carousel_controller"
import EnergyFlowController from "./energy_flow_controller"
import NavbarController from "./navbar_controller"
import VideoPlayerController from "./video_player_controller"

application.register("audio", AudioController)
application.register("carousel", CarouselController)
application.register("landing-page-builder", LandingPageBuilderController)
application.register("quiz-builder", QuizBuilderController)
application.register("galaxy", GalaxyController)
application.register("copy-link", CopyLinkController)
application.register("form-hint", FormHintController)
application.register("modal", ModalController)
application.register("parallax", ParallaxController)
application.register("particles", ParticlesController)
application.register("quiz", QuizController)
application.register("countdown", CountdownController)
application.register("lgpd", LgpdController)
application.register("drag-sort", DragSortController)
application.register("reveal", RevealController)
application.register("lang-toggle", LangToggleController)
application.register("dismissible", DismissibleController)
application.register("sparkles", SparklesController)
application.register("product-carousel", ProductCarouselController)
application.register("energy-flow", EnergyFlowController)
application.register("navbar", NavbarController)
application.register("video-player", VideoPlayerController)
